import '../../../styles/active.scss';
import React, { useState, useEffect, useRef } from 'react';
import { ListView, Toast, Modal } from 'antd-mobile';
import { useHistory } from 'react-router';
import { getActiveList } from '../../../services/tscloud/active';
import { behavioralRecord } from '../../../services/tscloud/active';
import { checkPermisson } from '../../../services/tscloud/active';
import { getUser, getPlatConfig, toConference, getDefaultCover } from '../../../utils';
import moment from 'moment';
import sysConfig from '../../../sysConfig';
const { preRouteUrl } = sysConfig;
Toast.config({ duration: 1 });

const Alert = Modal.alert;

function ListWrap(props) {
  return <ul className="active-list">{props.children}</ul>;
}

function ActiveList() {
  const pageSize = 4;
  let [pageIndex, setIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { live: liveCover } = getDefaultCover();
  const history = useHistory();
  const dataS = new ListView.DataSource({
    getRowData: (dataBlob, sectionID, rowID) => {
      return dataBlob[sectionID][rowID];
    },
    rowHasChanged: (row1, row2) => row1 !== row2,
  });
  const [dataSource, setDataSouce] = useState(dataS);
  const { platMark, userName, userId, loginName } = getUser() || {};
  const { reqIp } = getPlatConfig() || {};

  const checkStatus = (startTime, endTime) => {
    let status;
    if (moment().isBefore(startTime)) {
      status = 0;
    } else if (moment().isBetween(startTime, endTime)) {
      status = 1;
    } else if (moment().isAfter(endTime)) {
      status = 2;
    }
    return status;
  };

  const getData = async function (page) {
    setLoading(true);
    const param = {
      pageIndex: page,
      pageSize: pageSize,
      funcStatus: '1',
      liveStatus: 'indue',
      dataStatus: '1',
      platMark,
      reqIp,
      orderby: 'startTime',
    };
    const statusMapper = new Map([
      [0, { text: '即将开始', className: 'will' }],
      [1, { text: '进行中', className: 'ing' }],
      [2, { text: '已结束', className: 'end' }],
    ]);
    try {
      const respActive = await getActiveList(param);
      if (respActive.success === 'true' && respActive.data) {
        const activeList = data.concat(
          respActive.data.rows.map((item) => ({
            title: item.activityName,
            classroom: item.roomName,
            startTime: item.startTime,
            endTime: item.endTime,
            duration: moment(item.endTime).diff(item.startTime),
            lessonId: item.id,
            liveBroadcast: item.liveBroadcast,
            status: statusMapper.get(checkStatus(item.startTime, item.endTime)),
            coverUrl: item.coverUrl,
          })),
        );
        setLoading(false);
        setData(activeList);
        setDataSouce(dataSource.cloneWithRows(activeList));
        setHasMore(respActive.data.pageIndex < respActive.data.totalPage);
        setIndex(page);
      } else {
        setLoading(false);
        Toast.fail(respActive.retDesc);
      }
    } catch (err) {
      setLoading(false);
      Toast.fail(err);
    }
  };

  const onEndReached = function () {
    if (!loading && hasMore) {
      getData(++pageIndex);
    }
  };

  const forwordTo = async function (lessonId, status) {
    const confirm = (text) => {
      Alert('提示', text, [
        { text: 'Cancel', onPress: null },
        { text: 'Ok', onPress: () => history.push(`${preRouteUrl}/livePlay/${lessonId}`) },
      ]);
    };
    try {
      const resp = await checkPermisson({
        conferenceId: lessonId,
        reqIp,
        id: userId,
        name: loginName,
        truename: userName,
        platmark: platMark,
      });
      if (resp && resp.success && resp.data) {
        const { base, permission, isFull, conferenceInfo, userInfo, errmessage } = resp.data;
        if (base.timeStatus === 1) {
          if (permission === 1) {
            if (isFull) {
              if (conferenceInfo && conferenceInfo.isLiving) {
                confirm('参与人数已达到上限，是否进入直播？');
              } else {
                Toast.info(errmessage || '参与人数已达到上限');
              }
            } else {
              if (
                conferenceInfo &&
                conferenceInfo.isLocked &&
                userInfo &&
                userInfo.role !== '3' &&
                userInfo.role !== '4'
              ) {
                if (conferenceInfo.isLiving) {
                  confirm('活动已锁定，是否进入直播？');
                } else {
                  Toast.info(errmessage || '活动已锁定！');
                }
              } else {
                await behavioralRecord({
                  userId,
                  jlType: '5',
                  liveType: '3',
                  liveId: lessonId,
                });
                toConference(resp.data);
              }
            }
          } else {
            if (conferenceInfo && conferenceInfo.isLiving) {
              confirm('活动已锁定，是否进入直播？');
            } else {
              Toast.info(errmessage || '无权限参加教研活动！');
            }
          }
        } else {
          if (base.timeStatus === 2) {
            Toast.info('活动尚未开始!');
          } else if (base.timeStatus === 3) {
            Toast.info('活动已结束！');
          } else {
            Toast.info('活动时间异常！');
          }
        }
      } else {
        Toast.info(resp.errmessage || '查询错误');
      }
    } catch (err) {
      Toast.info(err);
    }
  };

  useEffect(() => {
    getData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const listRef = useRef();
  const row = (rowData, sectionID, rowID) => {
    const { title, classroom, startTime, duration, lessonId, status, coverUrl } = rowData;
    return (
      <li className="active-list-item" key={rowID} onClick={() => forwordTo(lessonId, status)}>
        <div className="time-duration">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            style={{ fill: 'rgb(1, 174, 250)' }}
          >
            <path d="M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9a9 9 0 0 0 0-18zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path>
          </svg>
          <span>{startTime}</span>
        </div>
        <div className="post">
          <img src={coverUrl || liveCover} alt="" />
          <em className={`tag ${status.className}`}>{status.text}</em>
        </div>
        <div className="info">
          <p className="title">{title}</p>
          <p className="duration">时长：{moment(duration).format('DD天mm分ss秒')}</p>
          <p className="dept">教室：{classroom}</p>
        </div>
      </li>
    );
  };
  return (
    <ListView
      ref={listRef}
      dataSource={dataSource}
      renderHeader={null}
      renderFooter={() => (
        <div style={{ padding: 30, textAlign: 'center' }}>
          {hasMore ? (loading ? '加载中...' : '加载完成') : '没有更多'}
        </div>
      )}
      renderBodyComponent={() => <ListWrap />}
      renderRow={row}
      className="active-list-wrap"
      pageSize={pageSize}
      onScroll={() => {
        console.log('scroll');
      }}
      scrollRenderAheadDistance={500}
      onEndReached={onEndReached}
      onEndReachedThreshold={10}
    />
  );
}

export default ActiveList;
